import React, { Component } from 'react';
import  ReactDOM from 'react-dom'
//import {GraphQLVoyager} from 'graphql-voyager';
//import '../../../../node_modules/graphql-voyager/dist/voyager.css';
import BBIFrame from './BBIFrame';
import  "./bbutil"

//var hans =require ('./test.json');


class BBVoyager     extends BBIFrame {

 

        getUrl()
        {
           BBIFrame.scrolling="no";
          return "/bb/bbvoyager.html";
        }

}





export default BBVoyager; 